import locales from '../locales.json'

const options = {}
let locale = "en-GB";
const applySelectValue = s => {
    const value = s.options[s.selectedIndex].value;
    if (s.id === "locale") {
        locale = s.options[s.selectedIndex]?.value ?? "en-GB";
    } else {
        if (value == "") {
            delete options[s.id];
        } else if (value === "false") {
            options[s.id] = false;
        } else if (value === "true") {
            options[s.id] = true;
        }else {
            options[s.id] = value;
        }
    }
    render();
};

const render = () => {
    console.log(locale)
    document.getElementById("optionsOutput").innerText = JSON.stringify(options, null, 2);
    let output;
    try {
        output = new Intl.DateTimeFormat(locale, options).format(new Date());
    } catch (err) {
        output = err;
    }
    document.getElementById("dateOutput").innerText = output;
    document.getElementById("localeOutput").innerText = locale;
}


Object.entries(locales).forEach((locale) => {

    try {
        if (Intl.DateTimeFormat.supportedLocalesOf(locale[0]).length !== 0) {
            const option = document.createElement("option");
            option.value = locale[0];
            option.innerText = locale[0] + " - " + locale[1];
            if (option.value === "en-GB") {
                option.selected = "selected";
            }
            document.getElementById("locale").append(
                option
            )
        };
    } catch (e) { console.error(e) }
});

document.querySelectorAll("form select").forEach(s => {
    applySelectValue(s)
    s.addEventListener("change", () => {
        applySelectValue(s)
    })
})
render();
